export default "__VITE_ASSET__WMtmZP4___"